<template>
  <div class="page">
    <h2>Личная информация</h2>
    <div class="main">
      <form @submit.prevent="submit">
        <div v-if="loading" class="loading-overlay">
          <div
            class="spinner-border"
            style="width: 3rem; height: 3rem;"
            role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div class="vm-input-group">
          <div class="vm-label">
            <label for="clinic-last-name">Фамилия</label>
          </div>
          <div class="vm-input">
            <b-form-input
              v-model="form.lastName"
              id="clinic-last-name"
              type="text"
            ></b-form-input>
          </div>
        </div>
        <div class="vm-input-group">
          <div class="vm-label">
            <label for="clinic-first-name">Имя</label>
          </div>
          <div class="vm-input">
            <b-form-input
              v-model="form.firstName"
              id="clinic-first-name"
              type="text"
            ></b-form-input>
          </div>
        </div>
        <div class="vm-input-group">
          <div class="vm-label">
            <label for="clinic-middle-name">Отчество</label>
          </div>
          <div class="vm-input">
            <b-form-input
              v-model="form.middleName"
              id="clinic-middle-name"
              type="text"
            ></b-form-input>
          </div>
        </div>
        <div class="vm-input-group">
          <div class="vm-label">
            <label for="clinic-middle-name">Пол</label>
          </div>
          <div class="vm-input">
            <b-form-radio-group
              v-model="form.gender"
              :options="genders"
              name="radio-inline"
            ></b-form-radio-group>
          </div>
        </div>
        <div class="vm-input-group">
          <div class="vm-label">
            <label for="clinic-birthday">День рождения</label>
          </div>
          <div class="vm-input">
            <b-form-input
              v-model="form.birthDay"
              id="clinic-birthday"
              type="date"
            ></b-form-input>
            <!-- <b-form-datepicker v-model=""></b-form-datepicker> -->
          </div>
        </div>
        <div class="vm-input-group">
          <div class="vm-label">
            <label for="clinic-phone">Телефон</label>
          </div>
          <div class="vm-input">
            <the-mask
              v-model="form.phone"
              id="clinic-phone"
              class="form-control"
              :mask="'+7 (###) ###-##-##'"
            ></the-mask>
          </div>
        </div>
        <div class="vm-button-group">
          <button type="button" @click="reset" class="vm-button">Отмена</button>
          <button type="submit" class="vm-button vm-button-primary">
            Сохранить
          </button>
        </div>
      </form>
      <div class="avatar-wrap">
        <AvatarSelect @upload="selectAvatar" @remove="removeAvatar" :img="avatar" />
      </div>
    </div>
  </div>
</template>

<script>
import { TheMask } from 'vue-the-mask';
import AvatarSelect from '@app/components/uikit/AvatarSelect';
import { uploadImageApi } from '@app/services';

export default {
  components: {
    TheMask,
    AvatarSelect
  },
  data: () => ({
    genders: [
      { value: 'male', text: 'Мужской' },
      { value: 'female', text: 'Женский' },
      { value: null, text: 'Не скажу' }
    ],
    form: {
      firstName: null,
      lastName: null,
      middleName: null,
      gender: null,
      phone: null,
      birthDay: null
    }
  }),
  computed: {
    avatar() {
      return this.$store.state.clinic.personal.avatar;
    },
    loading() {
      return this.$store.state.clinic.loading;
    }
  },
  created() {
    this.reset();
  },
  methods: {
    async selectAvatar(file) {
      const avatar = await this.uploadFile(file);
      this.form.avatar = avatar;
      await this.$store.dispatch('clinic/saveAvatar', avatar);
      await this.$store.dispatch('permission/loadPermissions');
    },
    async removeAvatar() {
      this.form.avatar = null;
      this.$store.state.clinic.personal.avatar = null;
      await this.$store.dispatch('clinic/saveAvatar', null);
      await this.$store.dispatch('permission/loadPermissions');

    },
    async uploadFile(file) {
      const formData = new FormData();
      formData.append('file', file);
      return await uploadImageApi.upload(formData);
    },
    async submit() { console.log(this.form);
      await this.$store.dispatch('clinic/savePersonal', this.form);
      await this.$store.dispatch('permission/loadPermissions');
    },
    reset() {  console.log(this.$store.state);
      this.form = { ...this.$store.state.clinic.personal };
    }
  }
};
</script>

<style lang="scss" scoped>
form {
  position: relative;
}
.loading-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}
.page h2 {
  color: #737473;
  font-size: 1.5rem;
}
.main {
  display: flex;
}
.main form {
  width: 70%;
  padding: 2rem;
  border-radius: 0.25rem;
  background-color: #fff;
  border: 1px solid #ecedf0;
  box-shadow: 0 0 8px 5px rgba(0, 0, 0, 0.025);
}
.main .logo-selector {
  position: relative;
  overflow: hidden;
  border: 1px solid #ecedf0;
  display: flex;
  width: 30%;
  flex-direction: column;
  margin-left: 2rem;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  background-color: #fff;
  padding: 1rem;
  height: 300px;
  box-shadow: 0 0 8px 5px rgba(0, 0, 0, 0.025);
}
.main .logo-selector .logo-selector-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  transition: opacity 100ms;
  padding-bottom: 2rem;
  opacity: 0;
}
.main .logo-selector:hover .logo-selector-overlay {
  opacity: 1;
}
.main .logo-selector button {
  color: #8adef5;
  background-color: transparent;
  border: 1px solid #8adef5;
  font-weight: 300;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  outline: none;
}
.main .logo-selector img {
  max-width: 100%;
  max-height: 100%;
}
h2 {
  color: #212121;
  margin-bottom: 2rem;
}
.vm-input-group {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}
.vm-input-group .vm-label {
  width: 30%;
}
.vm-input-group .vm-input {
  width: 70%;
}
.vm-input-group .vm-label label {
  color: #a3aab2;
  margin: 0;
}
.vm-button-group {
  text-align: right;
  margin-top: 2rem;
}
.vm-button {
  font-weight: 300;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 3px;
  color: #6cbdee;
  padding: 0.5rem 1rem;
  transition: all 200ms;
  outline: none;
  margin: 0;
}
.vm-button:hover {
  border: 1px solid #6cbdee;
  background-color: #6cbdee;
  color: #fff;
}
.avatar-wrap {
  width: 30%;
  display: flex;
  justify-content: center;
}
</style>
